import parse from 'date-fns/parse'
import differenceInYears from 'date-fns/difference_in_years'

import {
  AGE_LIMIT_UNDERAGE,
  LOWER_AGE_LIMIT,
  UPPER_AGE_LIMIT
} from '../constants'

export function getAge (birthDate) {
  return differenceInYears(new Date(), parse(birthDate))
}

export function getFullName (user) {
  if (!(user && user.privateAccount)) {
    return ''
  }

  return `${user.privateAccount.lastName} ${user.privateAccount.firstName}`
}

export function getCombinedAverageRating (user) {
  if (!user || user.ratingCount === 0) {
    return 0
  }

  return (user.rating1Avg + user.rating2Avg + user.rating3Avg) / 3
}

export function getUserCategory ({ isAdvertiserView, isCorporation } = {}) {
  let userCategory
  if (isAdvertiserView) {
    userCategory = 'Advertiser'
  } else {
    userCategory = isCorporation ? 'Company' : 'Private Employer'
  }

  return userCategory
}

export function formatPhone (phone) {
  return phone ? `+36${phone.replace(/\D/g, '')}` : ''
}

export function unformatPhone (phone) {
  return phone ? phone.replace(/^\+36/, '') : ''
}

export function isUnderage (birthDate) {
  return getAge(birthDate) < AGE_LIMIT_UNDERAGE
}

export function isLegalApprovalRequired (birthDate) {
  let age = differenceInYears(new Date(), parse(birthDate))
  return age >= LOWER_AGE_LIMIT && age <= UPPER_AGE_LIMIT
}



// WEBPACK FOOTER //
// ./src/utils/user.js